import {Component, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../core/utils/utils.service";
import {FormControl, FormGroup} from "@angular/forms";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {SecteurDTO} from "../../../core/dtos/secteur-dto";
import {SecteursService} from "../../../core/services/entities/secteurs.service";

@Component({
  selector: 'yo-secteurDialog',
  templateUrl: './secteur-dialog.component.html',
  styleUrls: ['./secteur-dialog.component.scss']
})
export class SecteurDialogComponent implements OnInit {

  subOpenDialog: Subscription

  secteur: SecteurDTO;

  form: FormGroup = new FormGroup({});

  dialogTitle: String = 'Modification d\'un secteur';

  sitePlaceholder: String = 'Selectionner le site...';

  displayDialog = false;

  idSelectedSite: number;

  constructor(private auth2Svc: Auth2Service,
              private toastSvc: ToastService,
              public secteursSvc: SecteursService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit() {
    this.initForm();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.secteursSvc.openDialogEdition$
      .subscribe((cdt: SecteurDTO) => {
        this.displayDialog = true;
        if (!cdt) {
          this.secteur = new SecteurDTO();
          this.secteur.id = 0;
          this.dialogTitle = 'Création d\'un secteur';
        } else {
          this.secteur = cdt;
          this.dialogTitle = 'Modification d\'un secteur';
        }
        this.initForm();
      });
  };

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  closeDialog = (): void => {
    this.displayDialog = false;
  };

  save = (): void => {
    if (this.form.valid) {
      let newFamille: SecteurDTO = {...this.secteur};
      newFamille.site = {id: this.idSelectedSite} as SiteDTO;
      newFamille.libelle = this.form.controls['libelle'].value;
      newFamille.actif = this.form.controls['actif'].value;
      this.secteursSvc.save(newFamille)
        .subscribe(response => {
          const isUpdate = newFamille.id !== null && newFamille.id !== undefined && newFamille.id !== 0;
          this.secteursSvc.announceSecteurSaved(response.one, isUpdate);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde du secteur réalisée avec succès`);
          this.closeDialog();
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.secteur?.site?.libelle : 'Selectionner le site...';
    this.idSelectedSite = this.secteur?.site?.id;
    this.form = new FormGroup({
      libelle: new FormControl(this.secteur?.libelle),
      actif: new FormControl(this.secteur?.actif != null ? this.secteur.actif : true)
    });
  };

  onChangeSite = ($event: any): void => {
    this.idSelectedSite = $event.selectedItem?.id;
  }

  canModify = () => {
    return this.secteursSvc.canModify(this.secteur);
  }

}
